export type CollapsedContentFrameDetail = {
  header: string;
  key: string;
};
export const collapsedContentFrameDetails: CollapsedContentFrameDetail[] = [
  {
    header: 'Resolution',
    key: 'resolution',
  },
  {
    header: 'Leader Frame ID',
    key: 'leader',
  },
  {
    header: 'Broadsign Frame ID',
    key: 'broadsignFrameId',
  },
  {
    header: 'Display Unit ID',
    key: 'displayUnitId',
  },
];
